import React, { useRef } from "react"
import { useBoundStore } from "../../../../zustand/store";

export interface InitialViewerCanvasSize {
    width: number,
    height: number,
}

const useViewerExternalSetup = (initialCanvasSize: InitialViewerCanvasSize) => {
  // @ts-ignore
  const { unityPlayerCanvasIsBeingUsed } = useBoundStore((state) => state);
  const unityPlayerCanvasRef = useRef(null);

    const canvasSize = {
    width: unityPlayerCanvasIsBeingUsed? initialCanvasSize.width : 0,
    height: unityPlayerCanvasIsBeingUsed? initialCanvasSize.height : 0,
  }

  const unityPlayerCanvasBuilt = <canvas
        ref={unityPlayerCanvasRef}
        id="unity-viewer-canvas"
        style={{ width: `${canvasSize.width}%`, height: `${canvasSize.height}${canvasSize.height && '%'}`,}}
      ></canvas>

    return {unityPlayerCanvasRef, unityPlayerCanvasBuilt, unityPlayerCanvasIsBeingUsed};
  
};

export default useViewerExternalSetup;
